import React from "react";
import classes from "./BottomBanner.module.css";

const BottomBanner = () => {
  return (
    <div className={classes.banner}>
      <div className={classes.bannerText}>
        <div className={classes.bannerHeading}>
          Current Promotions on All-Inclusive Detox Retreat Stays
        </div>
        <div>🎉 40% Off for Stays Before 31st October 2026</div>
        <div>🎉 35% Off for Stays From 1st November 2026 Onwards</div>
      </div>
      <a
        href="https://www.amitywellness.com"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.bannerLink}
      >
        ⬅ Return to Home Page
      </a>
    </div>
  );
};

export default BottomBanner;
